var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C5561719-2C79-4300-824D-E0609876ADD8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1012.000000, -800.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Checkbox",
    transform: "translate(1012.000000, 800.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-39",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 130,
    height: 22
  }), /*#__PURE__*/React.createElement("text", {
    id: "Title",
    fill: "none",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 6,
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17,
    y: 10,
    fill: "#000000"
  }, "Title")), /*#__PURE__*/React.createElement("text", {
    id: "Description",
    fill: "none",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 17,
    y: 17,
    fill: "#6F6F6F"
  }, "Description")), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333333,5 L6,5 C5.63181017,5 5.33333333,5.29847683 5.33333333,5.66666667 L5.33333333,11 C5.33333333,11.3681898 5.63181017,11.6666667 6,11.6666667 L11.3333333,11.6666667 C11.7015232,11.6666667 12,11.3681898 12,11 L12,5.66666667 C12,5.29847683 11.7015232,5 11.3333333,5 Z M6,5.66666667 L11.3333333,5.66666667 L11.3333333,11 L6,11 L6,5.66666667 Z",
    id: "Rectangle",
    fill: "#999999",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.d1215c7471115392b22e38541697f3c2.svg";
export { ForwardRef as ReactComponent };